module.exports = __webpack_public_path__ + "static/media/bgPublicGroup.8e307e34.png";